import { useState } from "react";
import SliderCaptcha from "@slider-captcha/react";
import { baseApi } from "@/lib/axios";

interface IProps {
  onVerifySuccess: (captchaToken: string) => void;
  warning: boolean;
}

export function SliderCaptchaBox({ onVerifySuccess, warning }: IProps) {
  const [requestId, setRequestId] = useState("");

  return (
    <div
      style={{
        ...(warning ? { border: "1px solid red", borderRadius: 4 } : {}),
      }}
    >
      <SliderCaptcha
        className="!w-full"
        create={async () => {
          const data = await baseApi<any>({
            url: `${process.env.API_PREFIX_IDENTITY}/v1/captcha/create`,
            method: "GET",
          });
          setRequestId(data.requestId);
          return data.data;
        }}
        verify={async (response: any, trail: any) => {
          const data = await baseApi({
            url: `${process.env.API_PREFIX_IDENTITY}/v1/captcha/verify`,
            method: "POST",
            data: { data: { response, trail }, requestId },
          });
          return data;
        }}
        callback={(data: any) => {
          onVerifySuccess(data);
        }}
        text={{
          anchor: "Tôi không phải robot",
          challenge: "Slide to finish the image",
        }}
      />
    </div>
  );
}
